/**
 * View mode constants for the product listing.
 *
 * Used by CatalogView (initial state) and CatalogSortRow (view toggle).
 *
 * list  — table/row layout, best for desktop comparison
 * tiles — card grid, works on all breakpoints
 * cards — compact card stack, designed for mobile
 */
export const VIEW_MODE = {
  LIST:  'list',
  TILES: 'tiles',
  CARDS: 'cards',
}
